import { CheckBadgeIcon } from '@heroicons/react/24/outline'
import Modal from '../common/Modal'
import { useMutation } from '@tanstack/react-query'
import { handlePatchRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { showToaster } from '../../utils/show-toaster.util'
import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'

export default function VerifyShopModal({ isOpen, onClose, shopName, shopId, id }) {
  const approveMutation = useMutation({
    mutationFn: () =>
      handlePatchRequest(`admin/shop/${shopId}/review`, {
        approve: true,
      }),
    onSuccess: () => {
      QueryKeys.adminShopVerificationDetails.invalidate(id)
      QueryKeys.adminListShopVerifications.invalidateAll()
      showToaster('success', 'Shop Approved')
      onClose()
    },
    onError: () => {
      showToaster('error', 'Failed to approve shop')
    },
  })

  const handleConfirm = () => {
    approveMutation.mutate()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-2">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Approve Shop</h3>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <CheckBadgeIcon className="w-6 h-6" />
            </div>
            <div>
              <h4 className="text-lg font-medium text-gray-900">Confirm Shop Approval</h4>
              <p className="text-sm text-gray-600">This action cannot be undone</p>
            </div>
          </div>

          <p className="text-gray-700 mb-6">
            Are you sure you want to approve the shop <strong>"{shopName}"</strong>? Once approved,
            the customers will see a verification badge next to the shop name.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-background border border-gray-300 rounded-md hover:bg-neutral-200-50 transition-colors font-medium"
            disabled={approveMutation.isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={approveMutation.isLoading}
          >
            {approveMutation.isLoading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Approving...
              </div>
            ) : (
              'Approve Shop'
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}
